<div id="course-page" class="page-body-content">
  <div class="header-border"></div>
  <div class="container">
    <div [hidden]="isCourseDataLoaded" class="spinner-container">
      <div class="d-flex justify-content-center">
        <div class="spinner-border custom-spinner" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div *ngIf="isCourseDataLoaded" class="flex-column-reverse flex-lg-row flex-xl-row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div class="course-name">{{ course.courseName }}</div>
        <div class="row d-flex">
          <div class="gridContainer">
            <div class="col-lg-9 course-heading" [innerHtml]="course.heading | safeHtml"></div>
            <div class="col-lg-3 back-to-learn"><a [routerLink]="['/learn']" class="primary-back-link nav-back">Back to Courses</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isCourseDataLoaded" class="course-purple-swoosh"><img src="assets/images/swipe-purple.svg" /></div>
  <div class="container">
    <div *ngIf="isCourseDataLoaded" class="row course-details">
      <div
        class="col-xl-4 col-lg-4 col-md-6 col-sm-12 justify-content-xl-start justify-content-lg-start justify-content-md-start justify-content-sm-start justify-content-start summary-section"
      >
        <div class="summary-heading"><span>SUMMARY</span></div>
        <div class="summary-text">
          <div [innerHtml]="course.description | safeHtml"></div>
        </div>
        <div class="course-start">
          <button
            class="btn-primary"
            *ngIf="!course.isCompleted"
            [routerLink]="['/topic']"
            [queryParams]="{ courseId: course.courseId, topicId: incompleteTopicIds[0] }"
          >
            {{ hasStarted ? 'Resume Course' : 'Start course' }}
          </button>
          <a
            *ngIf="course.isCompleted"
            [routerLink]="['/topic']"
            [queryParams]="{ courseId: course.courseId, topicId: 'T1' }"
            class="primary-back-link nav-back"
            >Restart course</a
          >
        </div>
      </div>
      <div
        class="col-xl-4 col-lg-4 col-md-6 col-sm-12 justify-content-xl-start justify-content-lg-start justify-content-md-start justify-content-sm-start justify-content-start topic-section"
      >
        <div class="topic-heading"><span>TOPICS</span></div>
        <div class="topic-list" *ngFor="let topic of course.topics">
          <div class="topic-item">
            <div class="topic-number">{{ topic.topicNumber }}.</div>
            <div class="topic-name">
              <a [routerLink]="['/topic']" [queryParams]="{ courseId: course.courseId, topicId: topic.topicId }" class="topic-name-link">{{
                topic.topicName
              }}</a>
            </div>
            <div class="topic-action primary-forward-link" *ngIf="!topic.topicCompleted && !course.isCompleted"></div>
            <div class="topic-action" *ngIf="topic.topicCompleted || course.isCompleted"><span class="completed">&#10003;</span></div>
          </div>
          <div><hr /></div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 justify-content-xl-start justify-content-lg-start justify-content-start course-image-section">
        <div class="course-image">
          <img
            src="{{ course.courseLandingImageUrl }}"
            [style.width]="course.courseLandingImageWidth"
            [style.height]="course.courseLandingImageHeight"
          />
        </div>
      </div>
    </div>
  </div>
</div>
